<template>
  <div class="color-type">
    <input
      :value="modelColor"
      class="value"
      @keyup.enter="updateColorfromInput"
    >
    <span
      v-tooltip="'Invalid Color Code entered'"
      v-if="!isValid"
      class="color-alert"><i class="fa fa-exclamation-circle"/></span>
  </div>
</template>

<script>
import chroma from 'chroma-js';

export default {
  props: {
    name: {
      type:    String,
      default: '',
    },
    color: {
      type:    String,
      default: '',
    },
  },
  data() {
    return { isValid: chroma.valid(this.color) };
  },
  computed: {
    modelColor() {
      return this.color;
    },
  },
  watch: {
    color(newVal, oldVal) { // watch it
      this.isValid = chroma.valid(newVal);
    },
  },
  methods: {
    updateColorfromInput(e) {
      const value = e.target.value;
      if (chroma.valid(value)) {
        this.$emit('inputColor', chroma(value).hex());
        this.isValid = true;
      } else {
        this.isValid = false;
      }
    },
  },
};
</script>
